import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addRelationship,
  deleteRelationship,
  getRelationship,
  updateRelationship,
} from "store/services/dataManagement/relationship";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All relationship
export const GetAllRelationshipAction = createAsyncThunk(
  "relationship/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getRelationship(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete relationship
export const DeleteRelationshipAction = createAsyncThunk(
  "relationship/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, ...rest } = payload;
      const res = await deleteRelationship(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        const responce = await getRelationship(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update relationship
export const UpdateRelationshipAction = createAsyncThunk(
  "relationship/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSucess, onError, ...rest } = payload;
    try {
      const res = await updateRelationship(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add relationship
export const AddRelationshipAction = createAsyncThunk(
  "relationship/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSucess, onError, filter, ...rest } = payload;
      const res = await addRelationship(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        const response = await getRelationship(filter);
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
